import angular from 'angular';
import uiModal from 'angular-ui-bootstrap/src/modal';
import {DijagnozaComponent} from './dijagnoza.component.js';
import DijagnozaFormComponent from './form/form.js';

const dijagnoza = angular.module('dijagnoza', [uiModal]);

dijagnoza.component('dijagnoza', DijagnozaComponent);
dijagnoza.component('dijagnozaForm', DijagnozaFormComponent);

export {dijagnoza};



// WEBPACK FOOTER //
// ./app/components/dijagnoza/dijagnoza.js